import type { ExportLogEntry, ExportLogGateway, RecordExportInput } from './exportLog';

/**
 * In-memory export log, like the other demo gateways. A real implementation MUST persist this and
 * must not allow deletion: the log is the evidence of what was handed to the tax advisor and when.
 * The interface is async from the start for exactly that reason.
 */
export class DemoExportLogGateway implements ExportLogGateway {
  private entries: ExportLogEntry[] = [];
  private sequence = 0;

  async listExports(tenantId: string): Promise<readonly ExportLogEntry[]> {
    return this.entries
      .filter((entry) => entry.tenantId === tenantId)
      .sort((left, right) => right.exportedAt.localeCompare(left.exportedAt));
  }

  async recordExport(input: RecordExportInput): Promise<ExportLogEntry> {
    this.sequence += 1;
    const entry: ExportLogEntry = {
      id: `export-${input.tenantId}-${this.sequence}`,
      tenantId: input.tenantId,
      from: input.period.from,
      to: input.period.to,
      exportedAt: new Date().toISOString(),
      exportedBy: input.exportedBy,
      format: input.format,
      rowCount: input.rowCount,
      debitorTotal: input.debitorTotal,
      kreditorTotal: input.kreditorTotal,
      checksum: input.checksum,
      fileName: input.fileName,
    };
    this.entries = [...this.entries, entry];
    return entry;
  }
}

export function createDemoExportLogGateway(): ExportLogGateway {
  return new DemoExportLogGateway();
}
